//include imports/storelocator/jquery.storelocator.js


// $(function () {
//
//
//     var $locator = $('#bh-sl-map-container');
//     $locator.each(function () {
//         var $this    = $(this);
//         var $geocode = $this.data('autogeocode') || null;
//
//         $locator.storeLocator({
//             'mapSettings': {
//                 zoom: 12,
//                 mapTypeId: google.maps.MapTypeId.ROADMAP,
//                 disableDoubleClickZoom: true,
//                 scrollwheel: false,
//                 navigationControl: false,
//                 draggable: true
//             },
//             'autoGeocode': $geocode,
//             'fullMapStart': true,
//             'slideMap': false,
//             'defaultLoc': true,
//             'defaultLat': '49.118869',
//             'defaultLng': '6.176850',
//             'markerImg': 'images/marker.png',
//             'markerDim': {'height': 60, 'width': 60}
//             // 'taxonomyFilters'  : {
//             // 	'product': 'products-filter'
//             // }
//         });
//     });
// });

// $(function () {
//     var $shop = $('.shop');
//     $shop.each(function () {
//         var $this    = $(this),
//             $google  = $('.google-infos'),
//             $placeid = $this.data('google-place-id'),
//             $modal   = $('#remodal-content-info'),
//             inst     = $('[data-remodal-id="shop"]').remodal();
//
//         // $this.on('click', '.shop-cover', function (e) {
//         //     $shop.removeClass('active');
//         //     $this.addClass('active');
//         // });
//
//         // $this.on('click', '.shop-close', function (e) {
//         //     $shop.removeClass('active');
//         // });
//
//         $this.on('click', '.details', function (e) {
//             e.preventDefault();
//             $('.ball-triangle').removeClass('loaded');
//             $modal.html('');
//             $modal.find('.alert').remove();
//             if ($placeid !== '') {
//                 $modal.html('<div id="google-photos" class="row gap pb center-xs middle-xs"></div>' +
//                     '<div class="filter-block"><label class="label-title closed"><div id="google-rating"></div><div id="schema"></div></label>' +
//                     '<div class="filter-content"><div class="google-infos"></div></div></div>' +
//                     '<div class="filter-block"><label class="label-title closed"><i class="fa fa-clock-o fa-fw"></i> Infos pratiques & Horaires</label>' +
//                     '<div class="filter-content"><div class="medium"><div id="google-address"></div><div id="google-phone"></div></div><hr><div id="google-hours"></div></div></div>');
//
//                 $modal.find('.google-infos').googlePlaces({
//                     //https://developers.google.com/places/place-id
//                     placeId: $placeid,
//                     render: ['rating', 'reviews', 'schema', 'address', 'hours', 'phone', 'photos'],
//                     min_rating: 3,
//                     max_rows: 0
//                 });
//
//             } else {
//                 $modal.append("<div class='alert alert-info'>Nous n'avons pas d'informations supplémentaires sur notre boutique</div>");
//             }
//             inst.open();
//             setTimeout(function () {
//                 $('.ball-triangle').addClass('loaded');
//                 $modal.attr('data-theme', $this.attr('data-theme'));
//                 $modal.find('.filter-block label.closed').siblings('.filter-content').hide();
//                 $modal.find('.filter-block').on('click', 'label', function () {
//                     $(this).toggleClass('closed').siblings('.filter-content').slideToggle(300);
//                 });
//             }, 2200);
//         });
//     });
// });

$(function () {
	var $unique_shop = $('section[itemtype="http://schema.org/Store"]');
	    $unique_shop.find('.google-infos').googlePlaces({
		//https://developers.google.com/places/place-id
		placeId   : $unique_shop.data('google-place-id'),
		render    : ['rating', 'reviews', 'schema', 'address', 'hours', 'phone', 'photos','staticMap'],
		min_rating: 3,
		max_rows  : 0
	});
});